<div>
    <render-image *ngIf="element.diagram" [element]="element.diagram"></render-image>
</div>